const url = {
  login: '/auth/login',
  stats: "/admin/stats/get",
  exam: {
    getAllExams: 'exam/getAllExam',
    getAllExamsLean: 'exam/getAllExamsLean',
    crateExam: 'exam/createExam',
    deleteOneExam: 'exam/deleteOneExam',
    updateExam: '/exam/updateExam',
    getExamById: '/exam/getExamById',
    updateExamStatus: '/exam/updateExamStatus',
    uploadCandidateData: '/examMapping/uploadUserCsvData',
    uploadZipUserData: "/examMapping/uploadZipUserData",
    getAllMappedUser: '/examMapping/getAllMappedUser',
    getAllMappedUserLean: '/examMapping/getAllMappedUserLean',
    deleteMappingForExam: '/examMapping/deleteExamMappingForExam',
    getExamLanguage: '/exam/getExamLanguages',
    setExamDateAndTime: '/exam/updateExamTime',
    setuserAllowedTillTime: '/exam/updateUserTillTime',
    setUserAllowedTime: '/exam/updateUserAllowedExamTime',
    markExamCompleted: '/exam/markAsCompleted',
    getAllUsers: '/exam/getAllExamStudents',
    getExamLayout: "/exam/getExamLayout",
    getExamInvigilatorStats: "/admin/exam/invigilator/stats"
  },
  admin: {
    getQuestionsByExamId: 'admin/getQuestionsByExamId',
    getQuestionById: 'admin/getQuestionById',
    addQuestionToExam: 'admin/addQuestionToExam',
    addAnswerToQuestion: 'admin/addAnswerToQuestion',
    addQuestionToQuestionById: 'admin/addQuestionToQuestion',
    makeExamive: '/admin/makeExamLive',
    getExamsections: '/admin/getExamSections',
    addOptionToQuestion: '/admin/addOptionToQuestion',
    deleteQuestionFromQuestionId: '/admin/deleteQuestionFromQuestionById',
    userAllowedStartTime: '/exam/userAllowedStartTime',
    getQuestionDataByExamIdAndSectionId:
      '/exam/getExamQuestionsByExamIdSectionId',
    deleteQuestionById: '/admin/deleteQuestionById',
    deleteOptionById: '/admin/deleteOptionById',
    deleteQuestionFromQuestion: '/admin/deleteQuestionFromQuestionById',
    getAllResponsesByExamId: '/admin/getAllResponsesByExamId',
    deleteStatementById: '/admin/deleteStatementById',
    getUserResponseByMappingId: '/admin/getUserResponseByMappingId',
    getAllCompletedUsersForExam: '/admin/getAllCompletedUsersForExam',
    getS3Link: "/admin/getS3Link",
    getDecriptionKeys: "/admin/getDecriptionKeys",
    setTimeMapping: '/admin/addChangeMappingTime',
    toggleUserActive: '/admin/toggleUserActive',
    resetMappingTime: "/admin/resetMappingTime",
    deleteQuestionDicomByQuestionDataId: "/admin/deleteQuestionDicomByQuestionDataId",
    deleteQuestionImageByQuestionDataId: "/admin/deleteQuestionImageByQuestionDataId",
    duplicateQuestion: "/admin/duplicateQuestion",
    questionMoveQuestionId: "/admin/question/move",
    user_logs: "/admin/user/logs",
    getAllUnmappedUsers: "/admin/user/unmapped",
    createMappedUser: "/admin/user/map",
    mapMultipleUsers: "/admin/user/map-multiple",
    toggleUpdate: "/admin/toggleUpdate",
    getStats: "/admin/stats/get",
    updateExamInstruction: "/exam/updateInstructions",
  },
  candidates: {
    getAll: '/admin/users',
    getDetails: '/admin/user/details',
    getExams: '/admin/user/exams',
    getTransactions: '/admin/user/transactions',
    approve: '/admin/user/approve',
    edit: '/admin/user/edit',
  },

  user: {
    getAllUsers: '/admin/getAllUser',
    resetPasswordForUser: '/user/resetPasswordForUser',
    deleteStudentMapping: '/examMapping/deleteStudentMapping',
    disableStudentMapping: '/examMapping/disableStudentMapping',
    toggleStudentMapping: '/examMapping/toggleStudentMapping',
    unMarkCompletedMapping: '/examMapping/unMarkCompletedMapping',
    genrateCertificate: '/certificate/generate',
    toggleMultipleStudentMapping:'/examMapping/toggleStudentMapping-multiple',
    updatePaymentDetails: '/examMapping/updatePaymentDetails',
  },
  logs: {
    getAllLogs: '/log/getAllLogs',
    getAllLogsByMappingId: "/log/getAllLogsByMappingId",
  },
  pulic: {
    getQuestionType: '/public/getQuestionTypes',
    getOptionType: '/public/getOptionTypes',
    getQuestionDataTypes: '/public/getQuestionDataTypes',
    getAllLanguages: '/public/getAllLanguages',
  },
  result: {
    getResultResponse: "/result/getResponses",
    getEncryptedOptionById: "/result/getencryptedOptionsById",
    createUserResultCSVByExamId: "/result/createUserResultCSVByExamId",
    ans_mark: "/answer/result/mark",
    getQuestionAnswersByExamId: "/answer/result/getQuestionAnswers",
    generateResult: "/answer/result/create",
    createUserResult: "/result/createUserResult",
    downloadExistingResultZip: "/result/downloadExistingResultZip",
  },

  invigilator: {
    getAllInvigilator: "/invigilator/getInvigilator",
    createInvigilator: "/invigilator/createInvigilator",
    deleteInvigilator: "/invigilator/deleteInvigilator",
    updateInvigilator: "/invigilator/updateInvigilator",
    resetPassword: "/invigilator/password/reset",
    getInvigilatorById: "/invigilator/getInvigilatorById",
    allotExam: "/admin/add/allottedExams",
    editAllotedExam: '/admin/update/allottedExams',
    changeStatus: '/invigilator/status',
    deleteAllotedExam: '/admin/exam/remove',
    getUnassignedForExam: '/admin/exam',
    assignToExam: '/admin/exam',
    createForExam: '/admin/exam',
    removeFromExam: '/admin/exam',
  },

  client: {
    getClients: '/admin/client',
    toggleBlockClient: '/admin/client/toggle-block',
    resetClientPassword: '/admin/client/reset-password',
    createClient: '/admin/client/create',
    updateClient: '/admin/client/update',
  },

  messageLogs: {
    getLogs: '/admin/message-logs',
  },

  settings: {
    get: '/settings/get',
    update: '/settings/update',
  },

  transactions: {
    getAllTransactions: '/admin/transaction/getAll',
    getTransactionById: '/admin/transaction/getById',
  },


  examGroup:{
    getAllExamGroups: '/examGroup',
    getExamGroupById: '/examGroup',
    getAllExamsInGroup:"/examGroup",
    createExamGroup: '/examGroup',
    addExamToGroup: '/examGroup',
    updateExamGroup: '/examGroup',
    deleteExamGroup: '/examGroup',
    removeExamFromGroup: '/examGroup/exam',
  }
};

export default url;
